/*ěščřžýáíéúů*/
/* Mega menu – desktop hover + mobile toggle */

(function ($) {
    'use strict';

    var DELAY  = 150;   // ms prodleva před zavřením na desktopu
    var BP_NAV = 1005;  // musí souhlasit s $_bp-nav v SCSS

    var $header    = $('header.site-header');
    var $menuBtn   = $header.find('.site-header__menu-btn');
    var closeTimer = null;

    /* ── helpers ─────────────────────────────────────────────────────────── */

    function getIdFromLi($li) {
        var m = ($li.attr('class') || '').match(/has-megamenu-([\w-]+)/);
        return m ? m[1] : null;
    }

    function isDesktop() {
        return window.innerWidth > BP_NAV;
    }

    /* ── inject toggle tlačítek pro mobil ───────────────────────────────── */

    $header.find('li[class*="has-megamenu-"]').each(function () {
        var id = getIdFromLi($(this));
        if (id) {
            $(this).find('> a').after(
                '<button class="megamenu-toggle" data-target="' + id + '" aria-label="Otevřít podmenu" aria-expanded="false">' +
                '</button>'
            );
        }
    });

    /* ── open / close ────────────────────────────────────────────────────── */

    function open(id) {
        clearTimeout(closeTimer);

        $header.find('.site-header-v2__megamenu.is-open').not('#megamenu-' + id)
            .removeClass('is-open').attr('aria-hidden', 'true');
        $header.find('[class*="has-megamenu-"].megamenu-is-open').not('.has-megamenu-' + id)
            .removeClass('megamenu-is-open');
        $header.find('.megamenu-toggle[aria-expanded="true"]').not('[data-target="' + id + '"]')
            .attr('aria-expanded', 'false');

        $('#megamenu-' + id).addClass('is-open').attr('aria-hidden', 'false');
        $header.find('.has-megamenu-' + id).addClass('megamenu-is-open');
        $header.find('.megamenu-toggle[data-target="' + id + '"]').attr('aria-expanded', 'true');
    }

    function scheduleClose(id) {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { close(id); }, DELAY);
    }

    function close(id) {
        clearTimeout(closeTimer);
        $('#megamenu-' + id).removeClass('is-open').attr('aria-hidden', 'true');
        $header.find('.has-megamenu-' + id).removeClass('megamenu-is-open');
        $header.find('.megamenu-toggle[data-target="' + id + '"]').attr('aria-expanded', 'false');
    }

    function closeAll() {
        clearTimeout(closeTimer);
        $header.find('.site-header-v2__megamenu').removeClass('is-open').attr('aria-hidden', 'true');
        $header.find('[class*="has-megamenu-"]').removeClass('megamenu-is-open');
        $header.find('.megamenu-toggle').attr('aria-expanded', 'false');
    }

    /* ── desktop: hover ──────────────────────────────────────────────────── */

    $header.on('mouseenter', 'li[class*="has-megamenu-"]', function () {
        if (!isDesktop()) return;
        var id = getIdFromLi($(this));
        if (id) open(id);
    });

    $header.on('mouseleave', 'li[class*="has-megamenu-"]', function () {
        if (!isDesktop()) return;
        var id = getIdFromLi($(this));
        if (id) scheduleClose(id);
    });

    $header.on('mouseenter', '.site-header-v2__megamenu', function () {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
    });

    $header.on('mouseleave', '.site-header-v2__megamenu', function () {
        if (!isDesktop()) return;
        var id = $(this).data('megamenu');
        if (id) scheduleClose(id);
    });

    /* ── mobil: toggle tlačítko ──────────────────────────────────────────── */

    $header.on('click', '.megamenu-toggle', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (isDesktop()) return;

        var id = $(this).data('target');
        if (!id) return;

        if ($(this).attr('aria-expanded') === 'true') {
            close(id);
        } else {
            open(id);
        }
    });

    /* ── mobil: křížek zavřít ────────────────────────────────────────────── */

    $header.on('click', '.megamenu__close', function () {
        closeAll();
    });

    /* ── global: zavřít ──────────────────────────────────────────────────── */

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') closeAll();
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.site-header-v2__megamenu, li[class*="has-megamenu-"]').length) {
            closeAll();
        }
    });

    // hamburger zavře i mega menu
    $menuBtn.on('click', function () {
        closeAll();
    });

}(jQuery));
